import styled from 'styled-components/macro';
import PropTypes from 'prop-types';
import { baseSpacing, colors } from 'css/constants';

const Chip = styled.div`
  background-color: ${colors.lightGrey};
  border-radius: 1em;
  display: ${({ inline }) => (inline ? 'inline-grid' : 'grid')};
  align-items: center;
  justify-items: ${({ justifyItems }) => justifyItems || 'start'};
  column-gap: ${({ columnGap }) => columnGap || undefined};
  row-gap: ${({ rowGap }) => rowGap || undefined};
  grid-template-columns: ${({ gridTemplateColumns }) =>
    gridTemplateColumns || 'auto 1fr auto'};
  padding: ${({ withLabel }) =>
    withLabel
      ? `${baseSpacing / 8}px ${baseSpacing / 4}px ${baseSpacing / 8}px ${
          baseSpacing / 2
        }px`
      : `${baseSpacing / 8}px ${baseSpacing / 2}px`};
  text-align: center;
  cursor: ${({ cursor }) => cursor || 'default'};

  & > svg {
    margin-right: ${(-1 * baseSpacing) / 4}px;
    margin-left: ${baseSpacing / 4}px;
    font-size: 1rem;
    opacity: 0.8;
  }

  & > * {
    flex-shrink: 0;
  }
`;

export const InstanceChip = styled(Chip)`
  background-color: ${colors.darkerGrey};
  color: white;
`;

export const BetaChip = styled(Chip)`
  background-color: ${colors.blue};
  color: white;
`;

export const FlexboxChip = styled(Chip)`
  background-color: ${colors.lightGrey};
  color: ${({ theme }) => theme.text};
`;

export const GroupChip = styled(Chip)`
  background-color: #4e5b60;
  color: white;
`;

export const UserChip = styled(Chip)`
  background-color: #608095;
  color: white;
`;

export const AlertChip = styled(Chip)`
  background-color: ${colors.red};
  color: white;
`;

export const PlanChip = styled(Chip)`
  display: inline-grid;
  background-color: ${colors.darkerGrey};
  color: white;
  line-height: 16px;
  padding: 2px 12px;
`;

Chip.propTypes = {
  inline: PropTypes.bool
};

Chip.defaultProps = {
  inline: false
};
